export const formatSubscriptionPlanData = (planData) => {
	if (!planData) return null;

	const { subTerm, ...planDetails } = planData;

	return { ...planDetails, term: subTerm };
};
